import Wow from '../vendor/wow';

const wowAnimate = () => {
  new Wow().init();
};

export default wowAnimate;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/wowAnimate.js